import React, {useRef, useState} from "react";
import {toPersianNumber} from "../utils/numberConversion";

const OtpInput = ({length, onChange}) => {
    const [otp, setOtp] = useState(Array(length).fill(""));
    const inputRefs = useRef([]);

    const handleChange = (e, index) => {
        const value = e.target.value;
        if (isNaN(value) || value.length > 1) return;

        const newOtp = [...otp];
        newOtp[index] = toPersianNumber(value);
        setOtp(newOtp);
        onChange(newOtp.join(""));
        if (value !== "" && index < length - 1) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && otp[index] === "") {
            if (index > 0)
                inputRefs.current[index - 1].focus();
        }
    };

    return (
        <div className="d-flex justify-content-center" dir="ltr">
            {otp.map((_, index) => (
                <input
                    key={index}
                    type="text"
                    maxLength="1"
                    value={otp[index]}
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    ref={(el) => inputRefs.current[index] = el}
                    className="form-control otp-input col"
                />
            ))}
        </div>
    );
};
export default OtpInput;